module.exports = __webpack_public_path__ + "img/solid-emblem.116822a0.svg";